import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QRCodeModule } from 'angularx-qrcode';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { VisitorRegistrationQRCodeComponent } from './visitor-registration-qrcode.component';



@NgModule({
  declarations: [
    VisitorRegistrationQRCodeComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    QRCodeModule
  ]
})
export class VisitorRegistrationQRCodeModule { }
